import React from 'react';

import {
  Flex,
  TextBold,
} from 'web-styled';

import Pro from './Pro';
import Client from './Client';
import OnboardingVideo from './OnboardingVideo';
import Trainer from './Trainer';
import Activity from './Activity';
import * as S from './styled';

type Props = {
  profile: any,
  notifications: any,
};

const Dashboard = ({
  profile,
  notifications,
}: Props) => {
  const isPro = profile.is_pro;

  const trainerVisible = !isPro && (profile.namespace === null || profile.namespace === 'gymcloud');

  return (
    <Flex fillSpace column>
      <S.Header>
        <TextBold color="#fff" size="30px">
          Dashboard
        </TextBold>
        {trainerVisible && <Trainer />}
      </S.Header>
      <Flex fillSpace scrollY>
        {isPro ? <Pro /> : <Client />}
        <Flex flex="0 0 236px">
          <S.RightSide>
            {isPro && <OnboardingVideo />}
            <Activity
              notifications={notifications}
              isPro={isPro}
            />
          </S.RightSide>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Dashboard;
